import React from 'react';

const TreeEditorContext = React.createContext({});

export default TreeEditorContext;
